import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {TpAssetProfileService} from 'app/blocks/service/api/tp-asset-profile.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ITpAssetProfile, TpAssetProfile} from 'app/blocks/model/tp-asset-profile.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class TpAssetProfileResource extends AbstractEntityResource<ITpAssetProfile> {
    constructor(tpAssetProfileService: TpAssetProfileService, router: Router) {
        super(
            Resource.TP_ASSET_PROFILES,
            tpAssetProfileService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.TP_ASSET_PROFILES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.TP_ASSET_PROFILES),
            (entity?) => new TpAssetProfile(entity),
            (entity) => entity.profile_name,
            faStar
        );
    }
}
